<script>
const __ = wp.i18n.__;
import {
    onMount
} from 'svelte'
import {
    createFilterUrl
} from './api';
import Accordian from './Accordian.svelte'
import {
    getApiUrl,
    updateFilter
} from './Common.svelte';
import {
    selectedTags,
    selectedTagIds,
    selectedCates,
    selectedCateIds
} from './store';
import SelectedTags from './SelectedTags.svelte';

import AutoCompleteCustom from './AutoCompleteCustom.svelte'

export let onFilterChange;
export let allCategories;
export let allTags

export let adminPickedCategory = [];
export let adminPickedTags = [];
export let noofitems;

export let postType;

let seletedcat;
let tagID;
let articlesTypes;
let tempAdminCate,tempAdminTag;

export let clearTrigger;


export let ctypes = [{
        value: 313040,
        label: 'Happiness Program'
    },
    {
        value: 74889,
        label: 'Sahaj'
    },
    {
        value: 56368,
        label: 'Silence'
    },
]
let firstLoad = true;
function refreshSearch() {

    let f = updateFilter({
        types: !articlesTypes ? "" : articlesTypes,
        tag: !tagID ? "" : tagID,
        cat: seletedcat ? seletedcat : "",
        count: noofitems
    })
    const filter = updateFilter(f)
    const filterUrl = createFilterUrl(getApiUrl(), filter)
    onFilterChange(filterUrl)
}

function handleSubmit(event) {
    event.preventDefault()
    refreshSearch()
}

let ctMap = new Map(ctypes.map((ct) => [ct.value, ct]))
let tagsUnsubscribe;
let typeUnsubcsribe;

onMount(() => {
    tagsUnsubscribe = selectedTagIds.subscribe(onTagSelectionChange);
    typeUnsubcsribe = selectedCateIds.subscribe(onCategorySelectionChange)
    ctMap.forEach((ct, key) => {
        ct.checked = false;
    })
    if (postType === 'alltypes') {
        articlesTypes = '';
    } else if (postType === 'post') {
        articlesTypes = 'post';
        
    } else if (postType === 'video_posts') {
        articlesTypes = 'video_posts'
    }
    articlesTypes = articlesTypes
    refreshSearch();
    return () => {
        tagsUnsubscribe();
        typeUnsubcsribe()
    }
})

function onTagSelectionChange(tag) {
    tagID = tag.join(',')
    refreshSearch()
}

function onCategorySelectionChange(cat) {
    seletedcat = cat.join(',')
    refreshSearch()
}
const handleClear = () => {
    selectedTags.set([]);
    selectedTagIds.set([]);
    selectedCates.set([]);
    selectedCateIds.set([]);
    articlesTypes = "";
    postType = 'alltypes';
    refreshSearch()
}

let selectedEventType = 'alltypes';
const handleTypeChange = (event) => {
    selectedEventType = event.target.value;
    if (selectedEventType === 'alltypes') {
        articlesTypes = ''
    } else if (selectedEventType === 'post') {
        articlesTypes = 'post'
    } else if (selectedEventType === 'video_posts') {
        articlesTypes = 'video_posts'
    }
    refreshSearch()
}

$: clearTrigger = handleClear;

</script>

<!-- <Accordian/> -->
<div class="filter-container text-snd-banana w-full relative z-[99] ">
            <form on:submit={handleSubmit} class="rounded-2xl shadow-md p-5">

                <div class="flex gap-5 w-full flex-col md:flex-row">

                    <div class="w-full flex flex-col md:flex-[1_1_30%] md:w-auto">
                        <label class="block tracking-wide text-pm-grey text-base mb-1" for="event-type">
                            {__("Type", "frontend")}
                        </label>
                        <div class="relative">
                            <select id="event-type" name="event_type" class="block w-full text-l h-[44px] text-pm-grey border border-pm-grey bg-pm-white rounded-[10px] px-4 outline-0" on:change={handleTypeChange} bind:value={postType}>
                                <option id="alltypes" value="alltypes" class="text-l"> {__("All Types", "frontend")}</option>
                                <option id="post" value="post" class="text-l">{__("Articles", "frontend")} </option>
                                <option id="video_posts" value="video_posts" class="text-l">{__("Videos", "frontend")}</option>

                            </select>
                            <i class="select-down-arrow si-round si-expand-more text-3xl"></i>
                        </div>
                    </div>
                    <div class="w-full content-dropdown-holder categories-container flex-[1_1_100%] flex flex-col md:flex-[1_1_30%]  md:w-auto">
                        <span class="block tracking-wide text-pm-grey text-base mb-1" for="event-type">
                            {__("Categories", "frontend")}
                        </span>

                        <AutoCompleteCustom
                            type='categories'
                            content={allCategories}
                            adminPickedCategory={adminPickedCategory}
                            />

                            </div>
                            <div class="w-full content-dropdown-holder tag-container flex-[1_1_100%] flex flex-col md:flex-[1_1_30%]  md:w-auto">
                                <span class="block tracking-wide text-pm-grey text-base mb-1" for="event-type">
                                    Tags
                                </span>

                                <AutoCompleteCustom
                                    type='tags'
                                    content={allTags}
                                    adminPickedTags={adminPickedTags}
                                    />
                                    </div>
                                    
                            </div>
                            <div class="flex justify-between mt-3">
                                <SelectedTags />
                                <a href="#" class="text-pm-pink font-semibold content-center text-center text-l" type="reset" on:click|preventDefault={handleClear}>{__("Clear all", "frontend")}</a>
                            </div>

    </form>

</div>


<style>
/* input[type="date"]::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 0;
    opacity: 0.5;
    background-color: transparent;
    color: #000;
    height: 100%;
    width: 20%;
  } */
.filter-container select+.select-down-arrow {
    position: absolute;
    top: 50%;
    right: 10px;
    pointer-events: none;
    transform: translateY(-50%);
    color: #808080;
}
</style>
